function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "Grid"
}, React.createElement("text", {
  fill: "#fff",
  fontFamily: "Montserrat-Regular",
  fontSize: 13,
  transform: "translate(53.274 354.31)"
}, "0"), React.createElement("text", {
  fill: "#fff",
  fontFamily: "Montserrat-Regular",
  fontSize: 13,
  transform: "translate(37.284 306.005)"
}, "200"), React.createElement("text", {
  fill: "#fff",
  fontFamily: "Montserrat-Regular",
  fontSize: 13,
  transform: "translate(36.075 255.997)"
}, "400"), React.createElement("text", {
  fill: "#fff",
  fontFamily: "Montserrat-Regular",
  fontSize: 13,
  transform: "translate(36.751 205.425)"
}, "600"), React.createElement("text", {
  fill: "#fff",
  fontFamily: "Montserrat-Regular",
  fontSize: 13,
  transform: "translate(36.374 154.96)"
}, "800"), React.createElement("text", {
  fill: "#fff",
  fontFamily: "Montserrat-Regular",
  fontSize: 13,
  transform: "translate(28.613 105.105)"
}, "1,000"), React.createElement("text", {
  transform: "translate(1.224 10.897)"
}, React.createElement("tspan", {
  x: 0,
  y: 0,
  fill: "#fff",
  fontFamily: "Montserrat-Bold",
  fontSize: 10
}, "Congestion "), React.createElement("tspan", {
  x: 15.9,
  y: 12,
  fill: "#fff",
  fontFamily: "Montserrat-Bold",
  fontSize: 10
}, "Cost Per "), React.createElement("tspan", {
  x: 6.4,
  y: 24,
  fill: "#fff",
  fontFamily: "Montserrat-Bold",
  fontSize: 10
}, "Commuter"), React.createElement("tspan", {
  x: 49.5,
  y: 36,
  fill: "#fff",
  fontFamily: "Montserrat-Bold",
  fontSize: 10
}, "($)")), React.createElement("path", {
  fill: "none",
  stroke: "#8b93c4",
  strokeWidth: 0.565,
  d: "M73.7 301.6h192.7"
}), React.createElement("path", {
  fill: "none",
  stroke: "#8b93c4",
  strokeWidth: 0.565,
  d: "M73.7 251.6h192.7"
}), React.createElement("path", {
  fill: "none",
  stroke: "#8b93c4",
  strokeWidth: 0.565,
  d: "M73.7 201.5h192.7"
}), React.createElement("path", {
  fill: "none",
  stroke: "#8b93c4",
  strokeWidth: 0.565,
  d: "M73.7 151.5h192.7"
}), React.createElement("path", {
  fill: "none",
  stroke: "#8b93c4",
  strokeWidth: 0.565,
  d: "M73.7 101.5h192.7"
}), React.createElement("path", {
  fill: "none",
  stroke: "#8b93c4",
  strokeWidth: 0.565,
  d: "M73.7 51.5h192.7"
}), React.createElement("path", {
  fill: "none",
  stroke: "#8b93c4",
  strokeWidth: 0.565,
  d: "M73.5 1.3h192.9v350H73.5z"
}), React.createElement("path", {
  fill: "none",
  stroke: "#8b93c4",
  strokeWidth: 0.565,
  d: "M117.6 1.3v350"
}), React.createElement("path", {
  fill: "none",
  stroke: "#8b93c4",
  strokeWidth: 0.565,
  d: "M172.7 1.3v350"
}), React.createElement("path", {
  fill: "none",
  stroke: "#8b93c4",
  strokeWidth: 0.565,
  d: "M227.8 1.3v350"
}), React.createElement("text", {
  fill: "#fff",
  fontFamily: "Montserrat-Regular",
  fontSize: 13,
  transform: "translate(64.283 373.338)"
}, "\u201882"), React.createElement("text", {
  fill: "#fff",
  fontFamily: "Montserrat-Regular",
  fontSize: 13,
  transform: "translate(107.946 373.338)"
}, "\u201890"), React.createElement("text", {
  fill: "#fff",
  fontFamily: "Montserrat-Regular",
  fontSize: 13,
  transform: "translate(162.709 373.338)"
}, "\u201800"), React.createElement("text", {
  fill: "#fff",
  fontFamily: "Montserrat-Regular",
  fontSize: 13,
  transform: "translate(219.773 373.338)"
}, "\u201810"), React.createElement("text", {
  fill: "#fff",
  fontFamily: "Montserrat-Regular",
  fontSize: 13,
  transform: "translate(258.822 373.338)"
}, "\u201817"));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "Lines",
  fill: "none",
  strokeLinecap: "round"
}, React.createElement("path", {
  stroke: "#fff",
  strokeWidth: 2,
  d: "M73.7 137.5l5.5-5.8 5.5-10 5.5 10 5.5 9 5.5 14.3 5.5 10.3 5.5 4.3 5.5 5.3 5.5.5 5.5 1.8 5.5-1 5.5-3.8 5.5-5.8 5.5-3.8 5.5-6 5.5-5.8 5.5-7.3 5.5-4.8 5.5-17 5.5-11.5 5.5-9.5 5.5-1.5 5.5-7.3 5.5-2.8 5.5 4.5 5.5 7 5.5-13.5 5.5-2.8 5.5-9 5.5-25 5.5-13 5.5-8.3 5.5-7.5 5.5-8.3 5.5-6.3"
}), React.createElement("path", {
  stroke: "#fff",
  strokeWidth: 2,
  d: "M73.7 192.5l5.5-10.3 5.5-15.3 5.5 12 5.5 6.8 5.5-10.3 5.5-1.3 5.5 1.8 5.5-6.8 5.5-.3 5.5-3 5.5-2.8 5.5-2.5 5.5-8.5 5.5-6.8 5.5-4.3 5.5-8.3 5.5-8.8 5.5-3 5.5-.8 5.5-2 5.5-9 5.5-8.8 5.5-8.5 5.5-8.3 5.5.3 5.5 29.5 5.5-.5 5.5-7 5.5-7.8 5.5-10.8 5.5-6.8h5.5l5.5-6.5 5.5-7 5.5-6.3",
  opacity: 0.6
}), React.createElement("g", {
  stroke: "#fff",
  strokeWidth: 2,
  opacity: 0.8
}, React.createElement("path", {
  d: "M73.7 300.3l.2-.2"
}), React.createElement("path", {
  strokeDasharray: ".5642,.5642",
  d: "M74.2 299.6l5-6.8 5.5-3 5.5-2 5.5-6 5.5-1.2 5.5-.3 5.5-.7 5.5-6 5.5-4 5.5-5.3 5.5-5.2 5.5-5.3 5.5-8.2 5.5-14 5.5-12.5 5.5-11.8 5.5-12.5 5.5-6.5 5.5-13 5.5-7.8 5.5-8.5 5.5-10.7 5.5-5.5 5.5-6.3 5.5-11.5 5.5 6.3 5.5-3 5.5-14.3 5.5-9 5.5-15.2 5.5-7 5.5-3.5 5.5-12.8 5.5-16 5.5-16.2"
})), React.createElement("path", {
  stroke: "#fff",
  strokeWidth: 2,
  d: "M73.7 308.3l5.5-3.3 5.5-4 5.5-2.8 5.5-7.5 5.5-6.3 5.5-10.3 5.5-5 5.5-12.8 5.5-9.3 5.5-8.5 5.5-2.8 5.5-4.8 5.5-3.3 5.5-4.5 5.5-4.8 5.5-9.5 5.5-8.3 5.5 1 5.5-4.8 5.5-3.8 5.5-9.8 5.5 1.5 5.5 5.3 5.5 2 5.5.3 5.5 7.3 5.5-8 5.5-2 5.5-.3 5.5-3.5 5.5-.5 5.5-1.8 5.5-4.8 5.5-4.8 5.5-4",
  opacity: 0.6
}), React.createElement("path", {
  stroke: "#fff",
  strokeWidth: 2,
  d: "M73.7 279.3l5.5-3 5.5-.8 5.5-3.3 5.5-6.3 5.5.8h5.5l5.5-1.3 5.5-.8 5.5-3.8 5.5-9.5 5.5-9.8 5.5-8.8 5.5-14.3 5.5-11.5 5.5-10 5.5-4.3 5.5-4.5 5.5-3.8 5.5-3.3 5.5-4.5 5.5-2.5 5.5-3.8 5.5 2.3 5.5-2.5 5.5 2.3 5.5 4.8 5.5-4 5.5-8.5 5.5-2.8 5.5-7.3 5.5-7 5.5-1.5 5.5-5.3 5.5-4.8 5.5-5"
}), React.createElement("path", {
  stroke: "#fb7d74",
  d: "M73.7 209.6l5.5-6 5.5-9.1 5.5 6.6 5.5 3.4 5.5.9 5.5 2.7 5.5 1.2 5.5-1.7 5.5-1.2 5.5-2.6 5.5-3 5.5-4.1 5.5-7.4 5.5-6.5 5.5-6.2 5.5-7.3 5.5-7.9 5.5-3.7 5.5-7.6 5.5-6.2 5.5-7.6 5.5-4.8 5.5-5.3 5.5-4.3 5.5.7 5.5 14.8 5.5-5.9 5.5-5.8 5.5-6.1 5.5-13.6 5.5-7.6 5.5 25.6 5.5-5.7 5.5-7.4 5.5-4.6"
}));

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "Labels",
  fontFamily: "Montserrat-Bold",
  fontSize: 12
}, React.createElement("text", {
  fill: "#fff",
  transform: "translate(267.961 12.261)"
}, "Hou"), React.createElement("text", {
  fill: "#fff",
  transform: "translate(267.962 37.267)"
}, "Atx"), React.createElement("text", {
  fill: "#fff",
  transform: "translate(267.962 66.572)"
}, "Dfw"), React.createElement("text", {
  fill: "#fff",
  transform: "translate(267.962 135.465)"
}, "Satx"), React.createElement("text", {
  fill: "#fff",
  transform: "translate(267.961 176.31)"
}, "ELP"), React.createElement("text", {
  fill: "#fb7d74",
  transform: "translate(267.961 113.452)"
}, "U.S."));

var SvgS7MobileColors = function SvgS7MobileColors(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    id: "congestion",
    x: 0,
    y: 0,
    viewBox: "0 0 300 400",
    xmlSpace: "preserve"
  }, props), React.createElement("title", null, title), _ref2, _ref3, _ref4);
};

export default "data:image/svg+xml;base64,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";
export { SvgS7MobileColors as ReactComponent };